import { clearStoredAuth } from "./tokenManager";

export function normalizeApiError(error) {
  if (error.response?.data && typeof error.response.data === "object") {
    try {
      JSON.stringify(error.response.data);
    } catch (_serializationError) {
      error.response.data = {
        error: "Erro de comunicacao com o servidor",
        message: "Dados de resposta invalidos",
      };
    }
  }

  return error;
}

export function handleResponseError(error) {
  const normalizedError = normalizeApiError(error);

  if (normalizedError.code === "NETWORK_ERROR" || !normalizedError.response) {
    throw new Error("Erro de conexao com o servidor");
  }

  if (normalizedError.response?.status === 401) {
    clearStoredAuth();

    if (window.location.pathname !== "/login" && window.location.pathname !== "/") {
      window.location.href = "/login";
    }
  }

  return Promise.reject(normalizedError);
}
